import { InternalAxiosRequestConfig } from 'axios';
import { secureAxiosInstance, secureAxiosInstanceWithErrorMessageInterceptor } from '../api-service';
import { getTenant } from './get-tenant';

export function addTenantHeaderToRequest(requestConfig: InternalAxiosRequestConfig) {
  const tenant = getTenant();
  requestConfig.headers.set('X-Tenant', `${tenant.name}`);
  return requestConfig;
}

export async function SetUpTenantInfoSendWithHttpRequests() {
  secureAxiosInstance.interceptors.request.use(
    async requestConfig => addTenantHeaderToRequest(requestConfig),
    error => Promise.reject(error)
  );
  secureAxiosInstanceWithErrorMessageInterceptor.interceptors.request.use(
    async requestConfig => addTenantHeaderToRequest(requestConfig),
    error => Promise.reject(error)
  );
}
